import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { updateProjectBidDeadline } from '~/api/admin';

const defaults = {
  onError() {
    toast.error('Error occurred updating project deadline. Please try again.', { duration: 3000 });
  },
  onSuccess() {
    toast.success('Successfully updated bid deadline.', { duration: 3000 });
  }
};

export const useAddProjectDeadline = (params = {}) => {
  return useMutation({
    mutationFn: async ({ projectId, portfolioId, date }: any) => {
      try {
        await updateProjectBidDeadline({ portfolioId, projectId, date });
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    ...defaults,
    ...params
  });
};